import { Grid2 as Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { MainCard } from '../../../component/cards/MainCard2';
import PersonalData from './personalData';
import AccountData from './accountData';

const Profile = () => {
    const location = useLocation();
    const { user } = location.state || {};

    return (
        <MainCard title="DADOS">
            <Grid container spacing={2}>
                <Grid size={6}>
                    <PersonalData user={user} />
                </Grid>
                <Grid size={6}>
                    <AccountData user={user} />
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default Profile;
